import { CloseRounded } from "@mui/icons-material";
import { Box, Grid, IconButton, Input, Typography, useTheme, alpha } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { reduxHelper } from "../../../config/reduxHelper";
import { getString } from "../../../functions/getString";
import { IconButtonAnimate } from "../../animate";
import MenuPopover from "../../extras/MenuPopover";
import { iconsList } from "../iconsList";

const IconCollection = ({ children, selectedIcon, onPickIcon = () => {} }) => {

    const [open, setOpen] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [searchData, setSearchData] = useState(iconsList);

    const handleOpen = (event) => {
        setOpen(event.currentTarget);
    };
    
    const handleClose = () => {
        setOpen(null);
    };

    const theme = useTheme();

    const SECONDARY_TEXT = theme.palette.text.secondary;

    const searchIcon = () => {
        
        const newData = iconsList.filter(item => {
            const itemData = item.name.toUpperCase()
            const textData = searchText.toUpperCase()
            return itemData.indexOf(textData) > -1
        })

        setSearchData(newData)
        
    }

    useEffect(() => {
        searchIcon()
    }, [searchText])

    const dispatch = useDispatch();

    const updateComponent = () => {
        dispatch({
            type: reduxHelper.UPDATE_COMPONENT
        })
    }

    return (
        <>
            <IconButton
                onClick={handleOpen}
                sx={{
                    p: 0,
                    ...(open && {
                        '&:before': {
                        zIndex: 1,
                        content: "''",
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        position: 'absolute'
                        },
                    }),
                }}
                disableRipple
            >
                
                {children}

            </IconButton>

            <MenuPopover
                open={Boolean(open)}
                anchorEl={open}
                onClose={handleClose}
                sx={{
                    p: 2,
                    mt: 1.5,
                    '& .MuiMenuItem-root': {
                        typography: 'body2',
                        borderRadius: 0.75,
                    },
                    width: 410,
                    px: 3,
                    height: 450,
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                arrow={'right-top'}
            >

                <Typography variant={'subtitle1'} >{getString(' Choose icon')}</Typography>

                <Box
                    height={36}
                    width={'100%'}
                    sx={{ backgroundColor: 'divider' }}
                    borderRadius={1}
                    display={'flex'}
                    alignItems={'center'}
                    pl={2}
                    mb={2}
                    pr={0.5}
                    mt={2}
                >

                    <Input
                        placeholder={'Search icons'}
                        disableUnderline
                        sx={{ fontSize: 13 }}
                        fullWidth
                        onChange={(e) => {
                            setSearchText(e.target.value)
                        }}
                        value={searchText}
                    />

                    {
                        searchText?.length > 0 &&
                        <IconButton 
                            size={'small'} 
                            onClick={() => {
                                setSearchText('')
                            }}
                        >
                            <CloseRounded fontSize={'small'} />
                        </IconButton>
                    }

                </Box>

                <Box height={340} sx={{ overflow: 'hidden', overflowY: 'scroll' }} >
                    <Grid container gap={2} p={1} >
                        {
                            searchData?.map((i, index) => {
                                return (
                                    <Grid item >
                                        <Box
                                            height={65}
                                            width={55}
                                            sx={{ 
                                                backgroundColor: selectedIcon === i.name ? 'divider' : 'background.default',
                                                cursor: 'pointer',
                                                outline: `1px solid ${alpha(SECONDARY_TEXT, 0.1)}`,
                                                '&:hover': {
                                                    backgroundColor: 'divider',
                                                    outline: `1px solid ${SECONDARY_TEXT}`
                                                }
                                            }}
                                            display={'flex'}
                                            alignItems={'center'}
                                            justifyContent={'center'}
                                            borderRadius={1}
                                            onClick={() => {
                                                onPickIcon(i.name)
                                            }}
                                        >
                                            <span
                                                className={`mdi mdi-${i.name}`}
                                            />
                                        </Box>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                </Box>

            </MenuPopover>
        </>
    )
};

export default IconCollection;